module.exports = __webpack_public_path__ + "static/media/fastag.b2c1dac3.png";